import { useEffect, useRef } from 'react';
import { AppQualifier } from '../../utils/appQualifier';
import { useCheckoutState } from '../../utils/checkoutState';
import { config } from '../../utils/config';
import { mountScript } from '../../utils/useScript';

declare global {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface Window {
    _itt?: { c: string; s: string; t: string };
  }
}
const shopTrackingDomains: Record<AppQualifier['shop'], string> = {
  co: 'riverty-profile-tracking.comma-store.com',
  lb: 'riverty-profile-tracking.liebeskind-berlin.com',
  so: 'riverty-profile-tracking.soliver.com',
  tt: 'uc8.tv'
};

// https://docs.riverty.com/bnpl/documentation/profile_tracking#the-profile-tracking-tag
const AfterpayPayment = () => {
  const { checkoutState } = useCheckoutState();
  const token = checkoutState.orderState.payment?.selected?.[0].configuration?.initializationData?.deviceIdent?.token;
  const id = checkoutState.orderState.payment?.selected?.[0].configuration?.initializationData?.deviceIdent?.id;
  const previousToken = useRef();

  useEffect(() => {
    if (!token || token === previousToken.current) {
      return;
    }

    const conf = {
      c: id,
      s: token,
      u: window.location.pathname,
      h: shopTrackingDomains?.[config.shop],
      t: 'CO'
    };

    previousToken.current = token;
    window._itt = conf;
    const scriptUrl = `https://${conf.h}/container/${conf.c}?page=${conf.u}`;
    mountScript(scriptUrl);

    // eslint-disable-next-line consistent-return
    return () => {
      delete window._itt;
    };
  }, [token, previousToken]);

  return null;
};

export default AfterpayPayment;
